import { cva, type VariantProps } from 'class-variance-authority';
import { HTMLAttributes, JSX } from 'react';
import { cn } from '@/lib/utils';

const textVariants = cva('text-texts-default', {
  variants: {
    variant: {
      default: '',
      bold: 'font-semibold',
      italic: 'italic',
      link: 'underline underline-offset-4',
      title: 'font-eurostile',
    },
    level: {
      1: 'text-base leading-relaxed',
      2: 'text-sm leading-loose',
      3: 'text-xs leading-loose tracking-1',
    },
  },
  compoundVariants: [
    {
      variant: 'bold',
      level: 3,
      class: 'tracking-2',
    },
  ],
  defaultVariants: {
    variant: 'default',
    level: 1,
  },
});

export interface TextProps
  extends HTMLAttributes<HTMLElement>,
    VariantProps<typeof textVariants> {}

export const Text = ({
  className,
  variant,
  level,
  ...props
}: TextProps): JSX.Element => {
  return (
    <p className={cn(textVariants({ variant, level, className }))} {...props} />
  );
};
